<template>
  <div class="card mb-2" @click="onClick()">
    <div class="p-2 text-center card-header">
      <span class="text-uppercase font-weight-bold overflow-text">
        {{ cliente.nome_fantasia ?? cliente.razao_social }}
      </span>
      <h6 class="mt-0 font-weight-bold">
        {{ filters.currencyWithPrefix(cliente.valor) }}
      </h6>
    </div>
    <div class="p-2 text-center card-body">
      <div class="div-list d-flex justify-content-between">
        <label>ID Painel</label>
        <h6 class="mb-0 font-weight-bolder">
          {{ cliente.id }}
        </h6>
      </div>
      <div class="div-list d-flex justify-content-between">
        <label>CPF/CNPJ</label>
        <h6 class="mb-0 font-weight-bolder">
          {{ cliente.documento ? filters.formatDocument(cliente.documento) : '***' }}
        </h6>
      </div>
      <div class="div-list d-flex justify-content-between">
        <label>Status</label>
        <h6 class="mb-0 font-weight-bolder">
          <badge-status :ativo="cliente.ativo" size="xs" />
        </h6>
      </div>
      <div class="div-list d-flex justify-content-between">
        <label>Tempo de Vida</label>
        <h6 class="mb-0 font-weight-bolder">
          <badge-tempo-vida :tempo-vida="cliente.tempoVida" size="xs" />
        </h6>
      </div>
      <div class="div-list d-flex justify-content-between">
        <label>{{ cliente.ativo ? 'Data Contrato' : 'Data Cancelamento' }}</label>
        <h6 :class="['mb-0', 'font-weight-bolder', 'text-sm', cliente.ativo ? 'text-navy' : 'text-danger']">
          {{ filters.formatDate(cliente.ativo ? cliente.dataContrato : cliente.dataInativo, 'DD/MM/YY') }}
        </h6>
      </div>
      <div class="div-list d-flex justify-content-between">
        <label>Cidade</label>
        <h6 class="mb-0 font-weight-bolder text-sm text-uppercase">
          {{ cliente.cidade }} - {{ cliente.uf }}
        </h6>
      </div>
      <div class="div-list d-flex justify-content-between">
        <label>Passo no Wizard</label>
        <h6 class="mb-0 font-weight-bolder text-sm text-uppercase">
          {{ getWizardStepDescription(cliente.wizardStep) }}
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
import BadgeStatus from "@/views/pages/components/BadgeStatus.vue";
import BadgeTempoVida from "@/views/pages/components/BadgeTempoVida.vue";

export default {
  name: "ClienteCard",
  components: {
    BadgeStatus,
    BadgeTempoVida,
  },
  props: {
    cliente: {
      type: Object,
      required: true,
      default: () => { }
    },
  },
  data() {
    return {

    }
  },
  methods: {
    getWizardStepDescription(step) {
      if (!step) return 'Não iniciado';
      
      const descriptions = {
        1: 'Configuração do Hotel',
        2: 'Categorias de Quartos',
        3: 'Quartos',
        4: 'Categorias de Produtos',
        5: 'Produtos',
        6: 'Usuários',
        7: 'Configuração Concluída'
      };

      return descriptions[step] || `Step ${step}`;
    },
    onClick() {
      this.$router.push({
        name: 'ClienteFreemium',
        params: {
          id: this.cliente.id
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  border: 0.4px solid rgba(33, 37, 41, 0.28);
  cursor: pointer;

  .card-body {
    padding: 1rem;

    label {
      text-align: left;
    }
  }

  .overflow-text {
    width: 100%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .div-list {
    padding: 8px;
    border-bottom: 0.4px solid rgba(33, 37, 41, 0.2);
  }
}

.card-header {
  background-color: #344767;
  color: #fff !important;
}

.card-header h6 {
  color: #fff !important;
}

.card:hover {
  border: 0.4px solid rgba(33, 37, 41, 0.43);
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
}
</style>
